import store from '@/store';


export default function routerBeforeEnterInbox(to, from, next) {
  const { options: { messageInboxEnabled } } = store.getters['merchant/merchant'];

  if (!messageInboxEnabled) {
    const redirectRoute = {
      name: 'orderMenu',
      params: { merchantId: to.params.merchantId }
    };

    next(redirectRoute);
  }
  else {
    next();
  }
}
